import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/termometre.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import FilterMenu from './FilterMenu';
import List from './List';
import Error from '../../../dialogs/Error';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Termometres extends React.Component {
    state = {
        hide: false,
        open: undefined,
    };

    constructor(props) {
        super(props);
        props.all();
        this.props.setSearch(true);
    }

    componentDidMount() {
        this.props.setInventoryWindow("termometres");
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.displays_has_error) {
            this.setState({
                hide: false,
                open: undefined,
            });
            nextProps.props.all();
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_termometre');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const { open, all_employees, rol, local } = this.state;
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List search={[...this.props.window_searchs]} />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            active={all_employees}
                            rol={rol}
                            local={local}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Termometres.propTypes = {
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

Termometres = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Termometres);

Termometres = withRouter(Termometres);

export default Termometres;



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometres/Index.js